import { render, staticRenderFns } from "./HousingIndustryAutoComplete.vue?vue&type=template&id=71a73248&scoped=true&"
import script from "./HousingIndustryAutoComplete.vue?vue&type=script&lang=js&"
export * from "./HousingIndustryAutoComplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a73248",
  null
  
)

export default component.exports